import _ from 'lodash';
import { PROFFIT_SEARCH_PLAN_FREE, PROFFIT_SEARCH_PLAN_TRIAL, PROFFIT_SEARCH_PLAN_STANDARD, } from '../define/consts/proffit_search/proffit_search_service';
import { POSITION_CANDIDATES, PROFESSIONAL_POSITION_CANDIDATES, SERVICE_PROFFIT_SEARCH, } from '../define/consts/profile';
/**
 * 電話番号の表示
 * @param profile
 * @returns {*|string|string}
 */
export const getPhoneNumber = (profile = {}) => {
    const { phone1, phone2, phone3 } = profile.information || {};
    return (phone1 && phone2 && phone3 && `${phone1}-${phone2}-${phone3}`) || '';
};
/**
 * 役職の表示
 * @deprecated TS化した方を参照してください
 * @param profile
 * @param isClient
 * @param isBr
 * @returns {string|*}
 */
export const getPosition = (profile, isClient, isBr = false) => {
    const { position: rawPosition, positionOther } = _.get(profile, 'information') || {};
    const position = parseInt(rawPosition, 10);
    const list = isClient ? POSITION_CANDIDATES : PROFESSIONAL_POSITION_CANDIDATES;
    const otherPosition = list.find((row) => row.other);
    const found = list.find((candidate) => candidate.value === position);
    const isPositionOther = found === otherPosition;
    if (found) {
        if (isPositionOther) {
            return positionOther;
        }
        if (isBr) {
            return found.labelBr || found.label;
        }
        return found.label;
    }
    return '';
};
export const baseSkillLevels = _.range(1, 10);
export const getBaseSkillBorderClassName = (level, value) => {
    if (level < value) {
        return 'is-complete';
    }
    if (level === value) {
        return 'is-active';
    }
    return '';
};
/**
 * solution idからsolutionのurlを生成する
 * @param id
 * @returns {string}
 */
export const getSolutionUrlFromId = (id) => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}/solution/${id}`;
};
/**
 * 加入しているプランがトライアルプランか
 * @param plan
 * @returns {boolean}
 */
export const isProffitSearchTrialPlan = (plan) => plan === PROFFIT_SEARCH_PLAN_TRIAL.value;
/**
 * 加入しているプランがフリープランか
 * @param plan
 * @returns {boolean}
 */
export const isProffitSearchFreePlan = (plan) => plan === PROFFIT_SEARCH_PLAN_FREE.value;
/**
 * 加入しているプランがスタンダードプランか
 * @param plan
 * @returns {boolean}
 */
export const isProffitSearchStandardPlan = (plan) => plan === PROFFIT_SEARCH_PLAN_STANDARD.value;
/**
 * Proffit Searchの処理で参照する値を取り出して返す
 * @param profile
 * @returns {{
 *  isEndTrial: boolean, トライアルプランが切れているか
 *  hasTrialEndAt: boolean, トライアルに申し込んだことがあるか
 *  canRegistrationTrial: boolean, トライアルに申し込めるか
 *  trialCountDown: number, トライアルの残り日数
 *  trialTimeCountDown: number, トライアルの残り時間
 *  standardCountDown: number, スタンダードプランの残り日数
 *  standardTimeCountDown: number, スタンダードプランの残り時間
 *  showTrialAlert: boolean, トライアルのアラートを表示するか
 *  userAllowDeviceId: string, 登録端末のuuid
 *  enableProffitSearch: boolean, Proffit Searchが利用可能か
 *  hasProffitSearch: boolean, Proffit Searchの情報を持っているユーザーか
 *  isExpired: boolean, アカウントの有効期限が切れている
 *  isExpireApproach: boolean, アカウントの有効期限が30日以下
 *  memberExpireApproachCount: number, アカウントの有効期限が30日以下のメンバー数
 *  memberExpiredCount: number, アカウントの有効期限が切れているメンバー数
 *  freeAccountCount: number, 未使用のアカウント数
 *  unReadSlideCount: number, 受領ファイル内の未読数
 *  hasGroupAccount: number, グループアカウントの所持
 * }}
 */
export const getProffitSearchValues = (profile = {}) => {
    const proffitSearch = profile.proffitSearch || {};
    const enableServices = profile.enableServices || [];
    const enableProffitSearch = enableServices.some((v) => v.name === SERVICE_PROFFIT_SEARCH && v.enableAt);
    const hasProffitSearch = Object.keys(proffitSearch).length > 0;
    const isEndTrial = !!proffitSearch.isEndTrial;
    const hasTrialEndAt = !!proffitSearch.trialEndAt;
    const isFree = isProffitSearchFreePlan(proffitSearch.plan);
    return Object.assign(Object.assign({}, proffitSearch), { 
        // トライアルに申し込めるか
        canRegistrationTrial: !hasProffitSearch || (isFree && !isEndTrial && !hasTrialEndAt), 
        // Proffit Searchが利用可能な状態か
        enableProffitSearch, freeAccountCount: proffitSearch.freeAccountCount || 0, hasGroupAccount: !!proffitSearch.slideSearchGroupId, 
        // Proffit Searchの情報を持っているユーザーか
        hasProffitSearch,
        // トライアルに申し込んだことがあるか
        hasTrialEndAt,
        // トライアル期間が終了しているか
        isEndTrial, isExpireApproach: proffitSearch.isExpireApproach || false, isExpired: proffitSearch.isExpired || false, 
        // 所属グループの責任者か
        isGroupAdmin: proffitSearch.isGroupAdmin || false, memberExpireApproachCount: proffitSearch.memberExpireApproachCount || 0, memberExpiredCount: proffitSearch.memberExpiredCount || 0, 
        // スタンダードプランの終了アラートを表示するか
        showTrialAlert: !!proffitSearch.showTrialAlert, 
        // スタンダードプランが終わるまでの残日数
        standardCountDown: proffitSearch.standardCountDown || 0, 
        // スタンダードプランが終わるまでの残日数
        standardTimeCountDown: proffitSearch.standardTimeCountDown || 0, 
        // トライアルが終わるまでの残日数
        trialCountDown: proffitSearch.trialCountDown || 0, 
        // トライアルが終わるまでの残り時間
        trialTimeCountDown: proffitSearch.trialTimeCountDown || 0, unReadSlideCount: proffitSearch.unReadSlideCount || 0, 
        // 登録端末のID
        userAllowDeviceId: proffitSearch.userAllowDeviceId || '' });
};
